import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n/i18n'
import router from './router'
// import store from './store'
import './plugins/element.js'
import { MessageBox } from 'element-ui';
// import axios from './plugins/axios'
// import Debounce from '@/plugins/debounce.js'
import setUserInfo from '@/plugins/userInfo.js'

import VueCookie from 'vue-cookie'
import VueWow from 'vue-wow'
import animate from 'animate.css'
import { ready } from '@/plugins/axios.js'
import { createStore } from './store'

// 导入封装公共的转化文件
import fun from "./utils/PublicConversionFile.js"
import errorMessage from "./utils/errorMessage.js"
import setTags from "./utils/setTags.js"
Vue.prototype.$fun = fun
Vue.prototype.$errorMessage = errorMessage
Vue.prototype.$MessageBox = MessageBox
Vue.prototype.$setTags = setTags

// 导入封装公共的转化文件
import get_icon_name from "./utils/get_icon_name.js"
Vue.prototype.$get_icon_name = get_icon_name
// localStorage.setItem('language', 'en')
// let language = localStorage.getItem('language')
// Vue.prototype.$language = language ? language : "en"

Vue.prototype.$language = "en"

import RepliesAndComments from './components/public/RepliesAndComments.vue';  //发布评论或者回复
import handlePreviewSwiper from './components/public/handlePreviewSwiper.vue'; //图片放大
import ConfirmPrompt from './components/public/ConfirmPrompt.vue';  //确定提示框
import Loading from './components/public/Loading.vue';  //Loading
import NoData from './components/public/NoData.vue';  //无数据提示
import goBack from './components/public/goBack.vue';  //返回
import PopUps from './components/public/PopUps.vue';  //弹出框


import './components/suspension/Passenger.js';   //客服导入

// 注册公共组件
Vue.component('RepliesAndComments', RepliesAndComments);
Vue.component('handlePreviewSwiper', handlePreviewSwiper);
Vue.component('ConfirmPrompt', ConfirmPrompt);
Vue.component('Loading', Loading);
Vue.component('NoData', NoData);
Vue.component('goBack', goBack);
Vue.component('PopUps', PopUps);

Vue.config.productionTip = false
// Vue.prototype.$axios = axios
// Vue.component('Debounce', Debounce)

Vue.prototype.$sharedState = Vue.observable({
  screenWidth: window.innerWidth,
});

function handleResize() {
  // console.log('屏幕宽度变化:', window.innerWidth);
  Vue.prototype.$sharedState.screenWidth = window.innerWidth;
}

window.addEventListener('resize', handleResize);
handleResize();

//打开官网路由
let go_official_website_page = function(url){
	if(url && url != "" && url != "#"){
		let $language = Vue.prototype.$language
		let language = $language == "" || $language == "en" ? "" : `/${$language}`
		let host = `https://www.tozostore.com${language}${url}`
		window.open(host, '_blank')
	}
}
Vue.prototype.$go_official_website_page = go_official_website_page
Vue.use(animate).use(VueWow).use(VueCookie)

  console.log('redirect: router.currentRoute.fullPath')
  console.log(router.currentRoute.fullPath)

const store = createStore()

ready({ store, router })

// setUserInfo(store)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
